import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class IsNotAuthenticatedGuard {
  private authService = inject(AuthenticationService);
  private router = inject(Router);

  public canActivate(): Observable<boolean | UrlTree> {
    return this.authService.isAuthenticated().pipe(
      map((isAuthenticated) => {
        if (isAuthenticated) {
          return this.router.parseUrl('/');
        }

        return true;
      }),
    );
  }
}
